<template>
  <div class="help_center_detail">
    <Banner :top="0" />
    <main class="main">
      <div class="back">
        <img
          src="~@/assets/help/left_back.png"
          alt=""
          @click="$router.push('/help-center')"
        >
        <span @click="$router.push('/help-center')">回Spark帮助中心</span>
      </div>
      <component :is="componentIndex" />
      <!-- <demo /> -->
    </main>
    <div class="code_box">
      <div class="code_text">
        <h2>
          联系客服
        </h2>
        <p>微信搜索并关注 PositiveGrid 公众号，回复“我要入群”加入官方微信群，了解更多最新资讯。如有任何问题，请于Positive Grid微信公众号留言，我们会尽快给予回复。谢谢。</p>
      </div>
      <div class="code_img">
        <img
          src="~@/assets/help/code.jpg"
          alt=""
        >
        <p>微信搜索并关注PositiveGrid回复“我要入群”</p>
      </div>
    </div>
    <FooterCommon />
  </div>
</template>
<script>

import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  components: {
    Banner,
    FooterCommon,
    // demo,
    help1: () => import('@/pages/helpCenter/components/help1.vue'),
    help2: () => import('@/pages/helpCenter/components/help2.vue'),
    help3: () => import('@/pages/helpCenter/components/help3.vue'),
    help4: () => import('@/pages/helpCenter/components/help4.vue'),
    help5: () => import('@/pages/helpCenter/components/help5.vue'),
    help6: () => import('@/pages/helpCenter/components/help6.vue'),
    help7: () => import('@/pages/helpCenter/components/help7.vue'),
    help8: () => import('@/pages/helpCenter/components/help8.vue'),
    help9: () => import('@/pages/helpCenter/components/help9.vue'),
    help10: () => import('@/pages/helpCenter/components/help10.vue'),
    help11: () => import('@/pages/helpCenter/components/help11.vue'),
    help12: () => import('@/pages/helpCenter/components/help12.vue')
  },
  data () {
    return {
      componentIndex: 'help1'
    }
  },
  created () {
    if (this.$route.query.id) {
      this.componentIndex = 'help' + this.$route.query.id
    }
  }
}
</script>
<style lang="scss" scoped>
.help_center_detail {
    min-height: 300px;
    background: #fff;
    margin-top: 54px;
    font-family: PingFangSC-Regular, Roboto, Noto Sans SC, sans-serif;

    .back {
        background: #e7e7e7;
        display: flex;
        align-items: center;
        padding: 16px;
        font-size: 14px;
        color: #e02020;
        font-weight: bold;
        img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
        }
        img,
        span {
            cursor: pointer;
        }
    }

    .code_box {
        padding: 64px 72px;
        background: #f9cb7c;
        display: flex;
        justify-content: center;

        .code_text {
            flex: 1;
            color: #101010;
            margin-right: 48px;
            min-width: 304px;
            h2 {
                font-style: normal;
                font-weight: 900;
                font-size: 24px;
                margin-bottom: 24px;
            }
            p {
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                text-align: justify;
                justify-content: space-between;
            }
        }
        .code_img {
            width: 160px;
            // height: 204px;
                font-size: 12px;
                color:#333;
            img {
                width: 160px;
                height: 160px;
            }
            p{
                margin-top:10px;
                text-align: center;
                display: flex;
            }
        }
        @media (max-width: 768px) {
            flex-wrap: wrap;
            .code_text {
                margin-right: 0;
                margin-bottom:24px ;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/helpCenter/help-center-detail.vue